import { graphql, useStaticQuery } from 'gatsby';

const useBlogCategoryQuery = () => {
  const data = useStaticQuery(graphql`
    query BlogCategoryQuery {
      allWpCategory(
        filter: {
          parent: {
            id: {eq: null}
          },
          count: {
            gte: 1
          },
          slug: {
            nin: ["developers", "uncategorized", "whats-new", "all-articles"]
          }
        }
      ) {
        nodes {
          ...NavigationCategorySelectionBlogCategoryDetails
        }
      }
    }
  `);

  return data?.allWpCategory?.nodes || [];
};

export default useBlogCategoryQuery;
